<div
  tabindex="0"
  class="navbar__search"
  [class.navbar__search--focus]="isFocused"
  [class.navbar__search--hover]="isHovered"
  (mouseover)="isHovered = true"
  (mouseout)="isHovered = false"
  (focusin)="isFocused = true; isHovered = false"
  (focusout)="isFocused = false"
>
  <app-search-select-field
    placeholder="Seleccionar"
    [options]="options"
    [(selected)]="selectedType"
  />

  <div class="navbar__search-input-container">
    <input
      type="text"
      placeholder="Buscar"
      class="navbar__search-input"
      [(ngModel)]="searchTerm"
      (keyup.enter)="onSearch()"
      [disabled]="isSearching()"
    />
    <img
      src="public/icons/actions/search-icon.svg"
      alt="search icon"
      class="navbar__search-icon"
      [class.navbar__search-icon--searching]="isSearching()"
      (click)="onSearch()"
    />
  </div>
</div>
